// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WQ-Y8","rootMobile":"styles_rootMobile__Yx8z4"};